export default { Mr: 'Mr', Mrs: 'Mrs', Ms: 'Ms' };
